export const convertToArabicNumbers = (number) => {
    if (number === undefined || number === null) return "";
    return number.toString().replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};

export const formatNumber = (number, locale) => {
    if (number === undefined || number === null) return "0";
    const formattedNumber = new Intl.NumberFormat('fr-FR').format(number);
    if (locale === 'ar') {
      return formattedNumber.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
    }
    return formattedNumber;
  };